import { render } from "./UserActivityView.vue?vue&type=template&id=20ee42c4&scoped=true"
import script from "./UserActivityView.vue?vue&type=script&lang=js"
export * from "./UserActivityView.vue?vue&type=script&lang=js"

import "./UserActivityView.vue?vue&type=style&index=0&id=20ee42c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ee42c4"]])

export default __exports__